import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimeAllocationLocation, TimeAllocationWorkedService, TimeAllocationRole, TimeAllocation, TimeAllocationDetail } from '../shared/time-allocation.interface';
import { ApiService } from '../core/api.service';

@Injectable({
  providedIn: 'root',
})
export class TimeAllocationService {

  constructor(private api: ApiService) {
  }

  getTimeAllocationLocations(): Observable<TimeAllocationLocation[]> {
    return this.api.getRequest('api/v1/TimeAllocationSelfService/GetTimeAllocationLocations');
  }

  getTimeAllocationServices(): Observable<TimeAllocationWorkedService[]> {
    return this.api.getRequest('api/v1/TimeAllocationSelfService/GetTimeAllocationServices');
  }

  getTimeAllocationRoles(): Observable<TimeAllocationRole[]> {
    return this.api.getRequest('api/v1/TimeAllocationSelfService/GetTimeAllocationRoles');
  }

  getTimeAllocation(allocation_id): Observable<TimeAllocation> {
    return this.api.getRequest(`api/v1/TimeAllocationSelfService/GetTimeAllocation/${allocation_id}`);
  }

  getTimeAllocationHistory(): Observable<TimeAllocationDetail[]> {
      return this.api.getRequest('api/v1/TimeAllocationSelfService/GetTimeAllocationHistory');
  }

  save(data): Observable<any> {
    return this.api.postRequest('api/v1/TimeAllocationSelfService/SaveTimeAllocation/', data);
  }
}